import { useQuery } from "@tanstack/react-query"
import {
  FALLBACK_SITE_SETTINGS,
  isCateringVisible,
  isSiteCheckoutOpen,
  siteSettingsQueryOptions,
  type SiteSettings,
} from "@/lib/data/site-settings"

/**
 * Reads the toggles staff control from Admin → Settings → Store.
 *
 * The root loader prefetches this into the query cache and the SSR query
 * integration dehydrates it, so the first client render already has the real
 * value — no flash of a link that should not be there. If the prefetch failed,
 * the fetcher resolves to the build-time fallback rather than rejecting.
 */
export function useSiteSettings(): SiteSettings {
  const { data } = useQuery(siteSettingsQueryOptions)
  return data ?? FALLBACK_SITE_SETTINGS
}

/** Convenience for the many places that only care about catering. */
export function useCateringVisible(): boolean {
  return isCateringVisible(useSiteSettings())
}

/** Whether the cart, account and sign-up entry points should show. */
export function useSiteCheckoutOpen(): boolean {
  return isSiteCheckoutOpen(useSiteSettings())
}
